import React from 'react';
import { Grid, Typography } from '@mui/material';

import FromToAutocomplete from '../../FromToAutocomplete';
import SingleDatePickerGit from '@shared/components/CustomDatePicker/index';

import DesktopButtons from './DesktopButtons';
import MobileButtons from './MobileButtons';

const RenderSection = ({
  section,
  i,
  updateSection,
  airSectionRow,
  addFlightSection,
  removeFlightSection,
  maxSections = 6,
}) => {
  const isLast = i === airSectionRow.length - 1;

  const pickedDate =
    section.date || (i === 0 ? section.date : airSectionRow[i - 1].date);

  return (
    <Grid
      container
      key={section.id || `grid-render-section-${i}`}
      rowSpacing={1}
      alignItems="flex-start"
      sx={{ mt: { md: i > 0 ? '5px' : 'auto' }, mb: { xs: '4px', md: 0 } }}
      style={{
        position: 'relative',
        top: '-6px',
      }}
    >
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: '14px',
            color: '#636466',
            fontWeight: 600,
            height: '20px',
          }}
        >
          TRAMO {i + 1}
        </Typography>
      </Grid>

      <Grid
        container
        item
        xs={12}
        direction={{ xs: 'column', md: 'row' }}
        alignItems="center"
        sx={{ columnGap: { xs: 0, md: 1 } }}
      >
        <Grid item xs={12} md sx={{ flex: 1, width: '100%' }}>
          <FromToAutocomplete
            origin={section.origin}
            destination={section.destination}
            flightOrigin={originSelected =>
              updateSection(i, 'origin', originSelected)
            }
            flightDestination={destinationSelected =>
              updateSection(i, 'destination', destinationSelected)
            }
            sectionNumber={i}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md="auto"
          sx={{ flex: '0 0 auto', mt: { xs: 2, md: 0 }, width: '100%' }}
        >
          <SingleDatePickerGit
            dateInfo={date => updateSection(i, 'date', date.date_selected)}
            datePicked={pickedDate}
            arrayDates={airSectionRow}
            index={i}
            md={12}
            singleSelect="true"
          />
        </Grid>
        {i === 0 ? (
          ''
        ) : (
          <>
            <DesktopButtons
              isLast={isLast}
              index={i}
              maxSections={maxSections}
              totalSections={airSectionRow.length}
              addFlightSection={addFlightSection}
              removeFlightSection={removeFlightSection}
            />

            <MobileButtons
              isLast={isLast}
              index={i}
              maxSections={maxSections}
              addFlightSection={addFlightSection}
              removeFlightSection={removeFlightSection}
            />
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default RenderSection;
